import React from 'react';
import PropTypes from 'prop-types';

import logo from '../../../assets/images/sp-logo.svg';
import Placeholder from '../../Placeholder';

import {
  Logo,
  LogoutButton,
  LogoutButtonPlaceholder,
  LogoSection,
  MainSection,
  SwitchButton,
  SwitchSection,
  UserLocation,
  UserName,
  Wrapper,
} from './TabletHeader.style';

const TabletHeader = ({ location, copy, stylist, onLogout, onResetCurrentUser }) => (
  <Wrapper hide={['login', 'forgot-password', 'change-password', 'sign-up'].some(el => location.pathname.includes(el))}>
    <LogoSection>
      <Logo src={logo} alt="logo" />
    </LogoSection>
    {['login', 'forgot-password', 'change-password', 'sign-up', 'stylist/visit/'].every(
      el => !location.pathname.includes(el)
    ) ? (
      <MainSection>
        <div>
          <UserName>
            {stylist.given_name || <Placeholder w="100px" h="20px" />}{' '}
            {stylist.family_name || <Placeholder w="100px" h="20px" />}
          </UserName>
          <UserLocation>
            {stylist.city || <Placeholder w="100px" h="20px" />} {stylist.salon || <Placeholder w="100px" h="20px" />}
          </UserLocation>
          {Object.keys(copy).length !== 0 && copy.constructor === Object ? (
            <LogoutButton onClick={onLogout}>{copy.log_out}</LogoutButton>
          ) : (
            <LogoutButtonPlaceholder>
              <Placeholder h="28px" w="100px" />
            </LogoutButtonPlaceholder>
          )}
        </div>
      </MainSection>
    ) : (
      <MainSection />
    )}
    {['login', 'forgot-password', 'retrieve-profile', 'change-password', 'sign-up', 'stylist/visit/'].every(
      el => !location.pathname.includes(el)
    ) ? (
      <SwitchSection>
        <SwitchButton onClick={onResetCurrentUser}>{copy.switch_customer}</SwitchButton>
      </SwitchSection>
    ) : (
      <SwitchSection />
    )}
  </Wrapper>
);

TabletHeader.defaultProps = {
  copy: {},
};

TabletHeader.propTypes = {
  copy: PropTypes.shape({}),
  location: PropTypes.shape().isRequired,
  stylist: PropTypes.shape({}).isRequired,
  onLogout: PropTypes.func.isRequired,
  onResetCurrentUser: PropTypes.func.isRequired,
};

export default TabletHeader;



// WEBPACK FOOTER //
// ./src/components/StylistHeader/TabletHeader/TabletHeader.js